module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s02-1_s-bb46e408a9254c8c49184de8bef31864.png";